var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DoNotDisturb50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "M24,43C13.523,43,5,34.477,5,24S13.523,5,24,5s19,8.523,19,19S34.477,43,24,43z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M14 21H34V27H14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DoNotDisturb50);
export default __webpack_public_path__ + "static/media/icons8-do-not-disturb-50.340890272564380c4a3a2eb438af6e56.svg";
export { ForwardRef as ReactComponent };